const firebaseConfig = {
    apiKey: "AIzaSyAXnvZRz_fqtjfYh4w0KZYLCjZdKcRmoJM",
    authDomain: "console.smarterevents.ch",
    databaseURL: "https://smarter-events.firebaseio.com",
    projectId: "smarter-events",
    storageBucket: "smarter-events.appspot.com",
    messagingSenderId: "3217447586",
}

export default firebaseConfig